module.exports = __webpack_public_path__ + "img/ic_list_zanwu_bg@2x.bd880872.png";